import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MensajeSoporte } from '../entities/mensaje-soporte';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { ByaHttp } from 'app/services/bya-http';
import { AuthService } from '../../../../@bya/auth/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class SoporteService extends ByaHttp {

  constructor(
    private http: HttpClient,
	  protected dialog: MatDialog, private _authService: AuthService
  ) {
	  super(dialog, _authService);
  }

  post(mensajeSoporte: MensajeSoporte): Observable<any> {
    return this.http.post<MensajeSoporte>(this.baseUrl + 'api/Soporte', mensajeSoporte)
      .pipe(
        tap(_ => this.log('fetched task')),
        catchError(this.handleError<MensajeSoporte>('GUARDAR MENSAJE SOPORTE', null))
      );
  }
}
